(function() {
    var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame ||
    function(callback) {
        window.setTimeout(callback, 1000 / 60);
    };
    window.requestAnimationFrame = requestAnimationFrame;
})();




var Snow = (function(){
  	function Snow(){
      	this.flakes = [],
		this.flakeCount = 200,
		this.wind = 0,
        this.canvas = null,
        this.ctx = null,
        this.parent = null;
    }
  

	Snow.prototype.makeitsnow = function() {
		this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
		for (var i = 0; i < this.flakeCount; i++) {
			var flake = this.flakes[i];		
			flake.move(this.canvas,this.wind);
			flake.draw(this.ctx);
		}
      	var boundSnow = this.makeitsnow.bind(this);
		requestAnimationFrame(boundSnow);
	};

	Snow.prototype.init = function(container) {
    	this.parent = container;
		this.canvas = document.createElement('canvas');
      	this.canvas.classList.add("snow-canvas");
    	this.canvas.width = this.parent.offsetWidth;
		this.canvas.height = this.parent.offsetHeight;
    	container.append(this.canvas);
		this.ctx = this.canvas.getContext("2d");
		
		for (var i = 0; i < this.flakeCount; i++) {
			var size = (Math.random() + 0.2) * 3 + .5,
				x = Math.random() * this.canvas.width,
				y = Math.random() * this.canvas.height,
				vx = (Math.random() - 0.5) * 0.2,
				vy = size * 0.1,
				opacity = (Math.random() * 0.5) + 0.3;
			var flake = new Snowflake(
				size,
				x,
				y,
				vx,
				vy,
				opacity
			);
			this.flakes.push(flake);
		}
		this.makeitsnow();
      
        window.addEventListener("resize",function(){
          this.canvas.width = this.parent.offsetWidth;
          this.canvas.height = this.parent.offsetHeight;
      	});
	};

	function Snowflake(size, x, y, vx, vy, opacity) {
		this.size = size;
		this.x = x;
		this.y = y;
		this.vx = vx;
		this.vy = vy;
		this.opacity = opacity;
	}

	Snowflake.prototype.move = function(canvas,wind) {
		this.x += this.vx + Math.min(Math.max(wind, -10), 10);
		this.y += this.vy;
		
		// Wrap the snowflake to within the bounds of the page
		if (this.x > canvas.width + this.size) {
			this.x -= canvas.width + this.size;
		}

		if (this.x < -this.size) {
			this.x += canvas.width + this.size;
		}

		if (this.y > canvas.height + this.size) {
			this.x = Math.random() * canvas.width;
			this.y -= canvas.height + this.size * 2;
		}
	};
	
	Snowflake.prototype.draw = function(ctx){
		ctx.fillStyle = "rgba(255,255,255," + this.opacity + ")";
		ctx.beginPath();
		ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
		ctx.fill();
	}
  
    return Snow;
}());


  
window.onload = function() {
  setTimeout(function() {
    $.each($('.snow .gallery__image'), function(i,el) {
      	var snow = new Snow();
      	snow.init(el);
    });  
  }, 500);
}